/* eslint-disable */
import { Row, Col } from 'react-bootstrap';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";

import { Button, CardContent, Modal, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import Chip from '@mui/material/Chip';

import MainCard from 'components/MainCard';
import { getEquipmentStatusesByQuery } from 'components/axios/equipmentAxios';

import { useEnumApi } from 'contexts/EnumApiContext';
import { getEquipmentsCategoriesById } from 'components/axios/equipmentAlertsAxios';
import ComponentStatusDiv from 'components/inner/ComponentStatusDiv';
import EquipmentStatusExcelDownload from 'components/EquipmentStatusExcelDownload';
import { equipmentFaultStatusColors, getDiagnosisGradeColor } from 'data/data';
import EquipmentPartListMaintenance from 'components/inner/EquipmentPartListMaintenance';

const EquipmentStatusLayer = ({info}) => {
    const { getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true); setIsLoading(false); };
    const handleClose = () => setOpen(false);

    const separate = "___";
    const printRef = useRef(null);

    const [isLoading, setIsLoading] = useState(false);
    const [equipmentStatuses, setEquipmentStatuses] = useState(null);
    // const [grade, setGrade] = useState('');
    
    const [componentId, setComponentId] = useState(null);
    const [equipmentComponents, setEquipmentComponents] = useState([]);

    const [excelDatas1, setExcelDatas1] = useState([]);
    const [excelDatas2, setExcelDatas2] = useState([]);
    const [excelDatas3, setExcelDatas3] = useState([]);
    const [fileName, setFileName] = useState("");

    useEffect(()=>{
        if (info) {
            equipmentStatusesList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[info]);

    // 설비현황기준관리 목록
    const equipmentStatusesList = async () => {
        Promise.all([
            // 설비 현황
            getEquipmentStatusesByQuery({ "equipment.id": info.id, size:50}).then((data) => {
                if (data && data._embedded) {
                    const list = data._embedded.equipmentStatuses;
                    if (list) {
                        //console.log(list[0]);
                        setEquipmentStatuses(list[0]);
                        return list[0];
                    }
                }
                setEquipmentStatuses(null);
                return null;
            })
            ,
            // // 설비 등급
            // getDiagnosisExecutionsEquipmentsLowestGradeById(info.id).then((data)=>{
            //     setGrade(data);
            // }),
            // 구성부목록
            getEquipmentsCategoriesById(info.id).then((data)=>{
              if (data && data.length > 0) {
                  setEquipmentComponents(data);
                  // const result = data.find(item=>item.sensorYn)
                  // // console.log(result)
                  // if (result)
                    // equipmentPartsByComponentId(data[0].id);
                  return data;
              }
              setEquipmentComponents(null);
              return null;
            })
        ]).then((res)=>{
          if (res && res[1] && res[1].length > 0) {
            // const result = res[4].find(item=>item.sensorYn)
            const result = res[1][0];
            if (result)
              equipmentPartsByComponentId(result.id);
          // } else if (info?.equipmentCtgr?.parent?.parent?.code === 'EV' || info?.equipmentCtgr?.parent?.parent?.code === 'ES') {
          } else if (info?.latestEquipmentOp) {
            equipmentPartsByComponentId(-1);
          }

          const statuss = res[0];
          // console.log(statuss);
          if (statuss != null) {
            setFileName(info?.name+"_"+t('message.common.file.name.status.table')+"_" + Date.now());
            
            setExcelDatas1([t('message.common.subtitle.fieldChkUser'), statuss.chkUser, '', t('message.common.subtitle.inspection.date'), (statuss.chkYmd || '')
              , t('message.common.subtitle.installation.location')+'(No.)', statuss?.equipment?.location, '']);
            // console.log(excelDatas1);

            let excelDatas2 = [];
            if (statuss.basicItems != null && statuss.basicItems.length > 0) {
              let excelData2 = [];
              statuss.basicItems.map((bItem, i)=>{
                excelData2 = [];
                excelData2.push(bItem.itemNm);
                excelData2.push('');
                excelData2.push('');
                excelData2.push(bItem.value);
                excelDatas2.push(excelData2);
              })
            }
            // console.log(excelDatas2);
            setExcelDatas2(excelDatas2);

            let excelDatas3 = [[t('message.common.subtitle.item'),'','', t('message.common.subtitle.unit'), t('message.common.subtitle.design.value'), '', t('message.common.subtitle.remark'), '']];
            if (statuss.statusItems != null && statuss.statusItems.length > 0) {
              let excelData3 = [];
              let itemName ;
              statuss.statusItems.map((sItem, i)=>{
                excelData3 = [];
                itemName = sItem.itemNm ? sItem.itemNm.split(separate) : "_________".split(separate);

                if (itemName[0] != '' && itemName[1] != '') {
                  excelData3.push({col:1,value:itemName[0]});
                  excelData3.push({col:1,value:itemName[1]});
                  excelData3.push({col:1,value:itemName[2]});
                } else if (itemName[0] != '' && itemName[1] == '') {
                  excelData3.push({col:2,value:itemName[0]});
                  excelData3.push({col:0,value:itemName[1]});
                  excelData3.push({col:1,value:itemName[2]});
                } else if (itemName[0] == '' && itemName[1] != '') {
                  excelData3.push({col:0,value:itemName[0]});
                  excelData3.push({col:2,value:itemName[1]});
                  excelData3.push({col:1,value:itemName[2]});
                } else if (itemName[0] == '' && itemName[1] == '') {
                  excelData3.push({col:0,value:itemName[0]});
                  excelData3.push({col:0,value:itemName[1]});
                  excelData3.push({col:3,value:itemName[2]});
                }

                excelData3.push(sItem.unit);
                excelData3.push(sItem.value);
                excelData3.push('');
                excelData3.push('');
                excelData3.push('');
                excelDatas3.push(excelData3);
              })
            }
            // console.log(excelDatas3);
            setExcelDatas3(excelDatas3);
          }
        })
    };

    // 해당 구성부에 해당하는 자재목록
    const equipmentPartsByComponentId = (compId) => {
        setComponentId(compId);
    }

    //if (info) {
    return (
      <>
        <Button variant="contained" onClick={handleOpen} style={{minWidth:"unset", paddingTop:"2px", paddingBottom:"2px"}}>
          {t('message.common.file.name.status.table')}
        </Button>

        <Modal className="pop_box pop_box4" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <MainCard title="" modal darkTitle content={false} style={{width:"1500px"}}>
            <div style={{marginRight:"12px", textAlign:"right"}}>
              <Button variant="contained" color="primary" size="small" onClick={handleClose}>
                {t('message.common.btn.close')}
              </Button>
            </div>
            <CardContent>
            <Row className='maint_tabs_cont'>
                <Col sm={5} style={{padding:"0 10px"}}>
                  <MainCard className="center_table" content={false}  ref={ printRef }>
                    <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/popbullet.png`} alt='' /></span>&nbsp;
                    <Chip label={`[${info && info.name} (${info && info.equipmentNo}) ${t('message.common.file.name.status.table')}]`} color="success" />
                    {equipmentStatuses && 
                        <TableContainer>
                        <Table sx={{ minWidth: 400 }} aria-label="simple table" className="same_width">
                          <TableBody>
                            <TableRow>
                              <TableCell className="th" align="center" style={{border:"1px solid #f0f0f0"}}>{t('message.common.subtitle.fieldChkUser')}</TableCell>
                              <TableCell align="center" style={{border:"1px solid #f0f0f0", color : "#000"}}>{equipmentStatuses.chkUser || ''}</TableCell>
                              <TableCell className="th" align="center" style={{border:"1px solid #f0f0f0"}}>{t('message.common.subtitle.inspection.date')}</TableCell>
                              <TableCell align="center" style={{border:"1px solid #f0f0f0", color : "#000"}}>{equipmentStatuses.chkYmd}</TableCell>
                              <TableCell className="th" align="center" style={{border:"1px solid #f0f0f0"}}>{t('message.common.subtitle.installation.location')}</TableCell>
                              <TableCell align="center" style={{border:"1px solid #f0f0f0", color : "#000"}}>{equipmentStatuses.equipment && (equipmentStatuses.equipment.location || '')}</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer> 
                    }

                    <TableContainer>
                      <Table style={{marginTop:"10px"}} sx={{ minWidth: 400 }} aria-label="simple table">
                      <TableBody>
                        {equipmentStatuses && equipmentStatuses.basicItems && equipmentStatuses.basicItems.map(function(item, i) {
                            return (
                        <TableRow key={i} className='pop_tr'>
                            <TableCell className="th" align="center" colSpan="2">{item.itemNm}</TableCell>
                            <TableCell colSpan="2">{item.value || ''}</TableCell>
                        </TableRow>
                            )
                        }) }
                        <TableRow>
                            <TableCell className="th" align="center" colSpan="2" style={{width:"190px"}}>{t('message.common.subtitle.item')}</TableCell>
                            <TableCell className="th" align="center" style={{width:"90px"}}>{t('message.common.subtitle.unit')}</TableCell>
                            <TableCell className="th" align="center" style={{width:"170px"}}>{t('message.common.subtitle.design.value')}</TableCell>
                        </TableRow>
                        { equipmentStatuses && equipmentStatuses.statusItems && equipmentStatuses.statusItems.map(function(item2, i) {
                        // console.log(item2);
                            let itemName = item2.itemNm ? item2.itemNm.split(separate) : "_________".split(separate);
                            return (
                        <TableRow key={i} className='pop_tr'>
                            {(itemName[0] || itemName[1]) && 
                            <>
                            <TableCell align="center">{itemName[0]}{itemName[1] && (' | '+itemName[1])}</TableCell>
                            <TableCell align="center">{itemName[2]}</TableCell>
                            </>
                            }
                            {!(itemName[0] || itemName[1]) && 
                            <>
                            <TableCell colSpan="2" align="center">{itemName[2]}</TableCell>
                            </>
                            }
                            <TableCell align="center">{item2.unit}</TableCell>
                            <TableCell align="center">{item2.value || ''}</TableCell>
                        </TableRow>
                            )
                        }) }
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {(excelDatas2.length > 0 || excelDatas3.length > 0) &&
                    <div style={{textAlign:"right",marginRight:"5px"}}>
                      {/* <EquipmentMaintenanceExcelDownload excelDatas1={excelDatas1} excelDatas2={excelDatas2} excelDatas3={excelDatas3} info={info} /> */}
                      <EquipmentStatusExcelDownload excelDatas1={excelDatas1} excelDatas2={excelDatas2} excelDatas3={excelDatas3} title={`${info?.name} ${t('message.common.file.name.status.table')}`} filename={`${fileName}.xlsx`} />
                    </div>
                    }
                  </MainCard>
                </Col>

                <Col sm={7} style={{padding:"0 10px"}}>
                  <MainCard className="center_table" content={false}>
                    <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/popbullet.png`} alt='' /></span>&nbsp;
                    <Chip label={t('message.common.subtitle.component.status')} color="success" />
                    <TableContainer>
                      <Table sx={{ minWidth: 500 }} aria-label="simple table" style={{minWidth:"unset"}}>
                        <TableBody>
                          <TableRow className='pop_tr'>
                            <TableCell style={{textAlign:"left"}}>
                              <ComponentStatusDiv equipment={info} equipmentComponents={equipmentComponents} componentId={componentId} equipmentPartsByComponentId={equipmentPartsByComponentId} target="maintenance" />
                            </TableCell>
                            <TableCell align="center" style={{width:"200px", fontSize:"25px"}}>
                              {/* <span className={getDiagnosisGradeColor(grade)}>{t('message.common.subtitle.defect')} : {grade || '-'}</span> */}
                              <span className={equipmentFaultStatusColors.find(data => data.code === info.status)?.color}>{t('message.common.subtitle.defect')} : {getEnumValueByEnumNameAndCode('EquipmentFaultStatus',info.status)[0]?.title || '-'}</span>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </MainCard>

                  {componentId && <EquipmentPartListMaintenance equipment={info} componentId={componentId} />}
                
                </Col>
            </Row>
            </CardContent>
          </MainCard>
        </Modal>
      </>
    )
    //}
}

export default EquipmentStatusLayer;